"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestGroupInReportingPeriod = void 0;
/**
 * To note, this assumes there won't be deviations between "reportingDate + version",
 * implying that each "reportingDate" would have the same (max) versions across entities.
 * This aligns with all of our existing workflows today, but will need to revisit
 * if we start introducing "reportingDate + version" distinctions per entity
 */
const getLatestGroupInReportingPeriod = (inputData) => {
    let maxReportingDate = '0000-00-00';
    let maxVersion = -1;
    for (const { reportingDate, version } of inputData) {
        if (reportingDate.localeCompare(maxReportingDate) > 0) {
            maxReportingDate = reportingDate;
        }
        maxVersion = Math.max(maxVersion, version);
    }
    const outputData = [];
    for (const data of inputData) {
        const { reportingDate, version } = data;
        if (reportingDate === maxReportingDate && version === maxVersion) {
            outputData.push(data);
        }
    }
    return outputData;
};
exports.getLatestGroupInReportingPeriod = getLatestGroupInReportingPeriod;
//# sourceMappingURL=reportingPeriodUtils.js.map